import styled from "styled-components";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { GradientColorType } from "@super-ui/interfaces/SwiggyOne";

const pillColorVisibilityHigh = "#ddfbef";
const textColorVisibilityHigh = "#1ba672";
const pillColorVisibilityLow = "#fff0cd";
const textColorVisibilityLow = "#d07d00";

const bgColorProvider = (colorType: GradientColorType) => {
    if (colorType.isHigh) {
        return pillColorVisibilityHigh;
    } else if (colorType.isLow) {
        return pillColorVisibilityLow;
    }
};

const textColorProvider = (colorType: GradientColorType) => {
    if (colorType.isHigh) {
        return textColorVisibilityHigh;
    } else if (colorType.isLow) {
        return textColorVisibilityLow;
    }
};

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: flex-end;
`;

export const PillContainer = styled.div<{ colorType: GradientColorType }>`
    height: 24px;
    padding: ${props => props.theme.spacing.xxSmall} ${props => props.theme.spacing.xSmall};
    border-radius: 8px;
    background-color: ${props => bgColorProvider(props.colorType)};
    color: ${props => textColorProvider(props.colorType)};
`;

export const DeliveryCount = styled(Text)<{ colorType: GradientColorType }>`
    margin-right: ${props => props.theme.spacing.xxSmall};
    display: inline-block;
    color: ${props => textColorProvider(props.colorType)};
`;

export const DeliveryCountText = styled(Text)<{ colorType: GradientColorType }>`
    display: inline-block;
    color: ${props => textColorProvider(props.colorType)};
`;

export const SubText = styled(Text)<{ colorType: GradientColorType }>`
    margin-top: ${props => props.theme.spacing.xxSmall};
    text-transform: uppercase;
    color: ${props => textColorProvider(props.colorType)};
`;
